// src/components/CTASection.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="cta-section">
      <h2>Let's Translate Your Vision Into Every Language</h2>
      <p>
        Whether you're expanding your business internationally or need multilingual content 
        for local markets, we provide solutions tailored to your goals, audience, and tone.
      </p>
      {/* CTA Button linking to Contact/Start Project (Contact page) */}
      <NavLink to="/contact-us" className="btn btn-primary">
        Let’s Start a Project
      </NavLink>
    </section>
  );
};

export default CTASection;